module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_foldedHover-ebbf3fc81624ae3e2f2f114a15086fe6.jpg";